import { useSuspenseQuery } from '@tanstack/react-query'

import { GetPlantasBlocoService } from '@/features/plantas/services/get-plantas-bloco.service'
import { plantasKeys } from '@/features/plantas/utils'

export const useSuspensePlantasBloco = (idExternoBloco: number) => {
  return useSuspenseQuery({
    queryKey: plantasKeys.listaPorBloco(idExternoBloco),
    queryFn: async () => new GetPlantasBlocoService().execute(idExternoBloco).then((res) => res.data),
  })
}
